var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.cls,style:(_vm.style)},[_c('vue-editor',{class:_vm.cls2,attrs:{"value":_vm.content,"editorOptions":_vm.editorOptions,"editor-toolbar":_vm.customToolbar,"customModules":_vm.customModules,"useCustomImageHandler":""},on:{"input":_vm.handleChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }